import type { AiCapabilityPage } from "../schema.js";
import { LIVE, OWNER_ADMIN } from "./_shared.js";

/**
 * `INVITE-LINK-MANAGE` (@UC0216) — trang **redirect** (US-AIV2-0049): chat KHÔNG hỏi ô, KHÔNG có nút Đồng ý,
 * chỉ một câu giải thích + nút mở đúng màn hình `/groups/:groupId/settings` (ADR-0009 bất biến 5).
 * US-AIV2-0110 S10 (`@UC0259`): trước trỏ trang chủ nhóm `/groups/:groupId`; nay Cài đặt nhóm — có sẵn mục "Link mời" (US-E24.F53-0577).
 * Cửa mobile trang này chịu trách nhiệm (trang chat `INVITE-LINK` là task 0056 — khi trang đó lên, ba cửa này chuyển sang nó).

 * 🔴 Vai HẸP HƠN cảm giác ban đầu (US-AIV2-0049, review #827 H1 — ĐO từ guard thật, đừng nới lại):
 *   cả ba cửa link mời gác `@RequireGroupRoles(OWNER, ADMIN)` — thủ quỹ phát link mời là 403.
 *   Trang redirect chỉ mở màn hình, nên mời sai vai = dẫn người ta tới nút bấm vào là 403
 *   (CLAUDE.md §4 cấm: "dẫn member thường vào form quản trị rồi để 403 ở bước chốt").
 *   Khoá bằng `roles-parity.invariants.spec.ts` — nới ở đây mà GUI không nới thì test ĐỎ.
 */
export const INVITE_LINK_MANAGE = {
  id: "INVITE-LINK-MANAGE",
  uc: "@UC0216",
  tier: "redirect",
  status: LIVE,
  roles: OWNER_ADMIN,
  flags: [],
  slots: [],
  llm: {
    description:
      "Quản lý LINK MỜI vào nhóm: tạo, xem, thu hồi link mời, xem link còn hiệu lực hay đã hết hạn. KHÔNG phải link gắn một người đã có suất với tài khoản. Trang này đứng ở phía NGƯỜI PHÁT lời mời cho nhóm của mình; nếu câu nói về một lời mời ĐÃ GỬI TỚI người hỏi (\"lời mời của tôi\", \"ai mời tôi\", \"tôi nhận được lời mời\") thì đó là INVITE-ACCEPT, kể cả khi câu hỏi về hạn dùng.",
    examples: [
      "tạo link mời",
      "tao link moi",
      "gửi link vào nhóm",
      "gui link vao nhom",
      "gỡ link mời cũ",
      "link mời còn hạn không",
      // ——— 0105: thêm cho đủ 40 ———
      "lấy link mời vào nhóm",
      "lay link moi vao nhom",
      "tôi muốn mời thêm người bằng link",
      "toi muon moi them nguoi bang link",
      "thu hồi link mời",
      "thu hoi link moi",
      "tạo lại link mời mới",
      "tao lai link moi moi",
      "gửi nhầm link mời vào nhóm khác rồi",
      "gui nham link moi vao nhom khac roi",
      "link mời hết hạn chưa",
      "link moi het han chua",
      "làm sao để mời phụ huynh vào nhóm?",
      "lam sao de moi phu huynh vao nhom",
      "copy link mời cho tôi",
      "copy link moi cho toi",
      "xem các link mời đang còn hiệu lực",
      "xem cac link moi dang con hieu luc",
      "huỷ link mời đã phát",
      "huy link moi da phat",
      "mời người vào đội bóng bằng đường link",
      "moi nguoi vao doi bong bang duong link",
      "cho xin link tham gia nhóm",
      "cho xin link tham gia nhom",
      "tạo đường dẫn mời thành viên",
      "tao duong dan moi thanh vien",
      "xoá hết link mời cũ đi",
      "xoa het link moi cu di",
      "phát link mời cho cả lớp",
      "phat link moi cho ca lop",
      "quản lý link mời của nhóm",
      "quan ly link moi cua nhom",
      "link mời nhóm",
      "cho người mới vào nhóm bằng link",
      "cho nguoi moi vao nhom bang link",
    ],
  },
  screen: "/groups/:groupId/settings",
  screenShows: "invite_link",
  endpoints: [
    "GET /groups/{groupId}/invitations/link",
    "POST /groups/{groupId}/invitations/link",
    "DELETE /groups/{groupId}/invitations/link/{invitationId}",
  ],
  facts: [],
  templates: {
    redirect: "Mình mở màn hình nhóm để bạn lấy link mời nhé. Link có hạn — gỡ link cũ đi nếu bạn đã gửi nhầm chỗ.",
  },
  journey: { after: ["ONB-ADD-MEMBERS"] },
  help: { title: "Link mời vào nhóm", tryNow: "tạo link mời" },
} satisfies AiCapabilityPage;
